let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bquJ0")).then(() => parcelRequire('8O5CD'));